import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound, Loader2, ShieldCheck } from "lucide-react";

export default function PortalResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) {
      toast.error("Lien invalide");
      nav("/portail/connexion");
    }
  }, [token, nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Mot de passe trop court (8 caractères minimum)");
    if (password !== confirm) return toast.error("Les mots de passe ne correspondent pas");
    setBusy(true);
    try {
      await api.post("/portal/reset-password", { token, password });
      toast.success("Mot de passe réinitialisé ! Vous pouvez vous connecter.");
      nav("/portail/connexion");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur");
    } finally { setBusy(false); }
  };

  return (
    <>
      <Header />
      <main className="relative pt-40 sm:pt-44 pb-16 min-h-screen bg-gradient-to-br from-[#0A1128] via-[#14213d] to-[#0A1128] text-white overflow-hidden" data-testid="portal-reset-page">
        <div className="absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full opacity-20 pointer-events-none" style={{ background: "#06B6D4", filter: "blur(120px)" }} />
        <div className="relative max-w-md mx-auto px-4 sm:px-6">
          <div className="text-center mb-6">
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#06B6D4] text-[#0A1128] mb-3 shadow-xl">
              <KeyRound size={28} />
            </div>
            <div className="text-[10px] font-bold tracking-[0.3em] uppercase text-[#67E8F9]">Sécurité</div>
            <h1 className="display text-2xl sm:text-3xl font-extrabold mt-2 leading-tight">Nouveau mot de passe</h1>
            <p className="text-white/70 text-[13px] sm:text-sm mt-2">Choisissez un mot de passe robuste (8 caractères minimum).</p>
          </div>
          <form onSubmit={submit} className="bg-white text-[#0A1128] rounded-3xl p-5 sm:p-6 shadow-2xl space-y-3.5">
            <div><Label>Nouveau mot de passe *</Label><Input data-testid="reset-pwd" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} /></div>
            <div><Label>Confirmer *</Label><Input data-testid="reset-pwd-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} /></div>
            <Button type="submit" disabled={busy} data-testid="reset-submit" className="w-full bg-[#06B6D4] hover:bg-[#67E8F9] text-[#0A1128] font-bold py-5">
              {busy ? <><Loader2 className="animate-spin mr-2" size={16} />Réinitialisation…</> : <><ShieldCheck size={16} className="mr-2" />Réinitialiser</>}
            </Button>
          </form>
        </div>
      </main>
      <Footer />
    </>
  );
}
